/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import { listStyles } from "@monsma/Overrides/Widgets/MyLists/MyListsList";
import { styledBox } from "@monsma/XDL/Components/Common/Box";
import { css } from "styled-components";

listStyles.wishListsWrapper = {
    css: css`
        ${styledBox};
        border-radius: 0;
        padding: 0;
        margin: 20px;
        width: 100%;
    `,
};

listStyles.cardListGrid = {
    width: 12,
    css: css`
        display: block;
    `,
};

listStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            border-bottom: 1px solid ${getColor("common.ui12")};
            padding: 0;

            &:last-child {
                border-bottom: 0;
            }
        `,
    },
};
